export interface SaleLineDescriptionVariable {
  key: string;
  label: string;
  description: string;
}

/** Variables disponibles en la descripción de líneas de suscripción. */
export const SALE_LINE_DESCRIPTION_VARIABLES: SaleLineDescriptionVariable[] = [
  {
    key: 'fecha',
    label: 'Fecha',
    description: 'Fecha del ciclo de cobro (dd/MM/yyyy). Prefijo ! para mayúsculas'
  },
  {
    key: 'fechaHora',
    label: 'Fecha y hora',
    description: 'Fecha y hora del ciclo (dd/MM/yyyy HH:mm). Prefijo ! para mayúsculas'
  },
  {
    key: 'mes',
    label: 'Mes',
    description: 'Nombre del mes del ciclo (ej. Septiembre). Prefijo ! para mayúsculas (SEPTIEMBRE)'
  },
  {
    key: 'año',
    label: 'Año',
    description: 'Año del ciclo (ej. 2026). Prefijo ! para mayúsculas'
  }
];
